import { useCallback, useState } from 'react';
import { useMusic24Capabilities } from '../hooks/useMusic24Capabilities';
import { defaultSocialDays, isSocialPeriodLocked, SocialPeriodDays } from '../promote/socialPeriod';

/**
 * The period of the Performance screen. It starts at 28 days (7 on Free). A period past the
 * history window of the plan cannot be picked: the picker shows the upgrade prompt for it.
 */
export function useSocialPeriod() {
  const { historyDaysLimit } = useMusic24Capabilities();
  const [picked, setPicked] = useState<SocialPeriodDays>();

  // A plan change can make the picked period too long. The default period is always permitted.
  const days =
    picked === undefined || isSocialPeriodLocked(picked, historyDaysLimit)
      ? defaultSocialDays(historyDaysLimit)
      : picked;

  const setDays = useCallback(
    (next: SocialPeriodDays) => {
      if (!isSocialPeriodLocked(next, historyDaysLimit)) {
        setPicked(next);
      }
    },
    [historyDaysLimit]
  );

  return { days, setDays, historyDaysLimit };
}
